import {Injectable} from "@angular/core";
import {contextPath} from "site";
import {HttpClient} from "@angular/common/http";
import {ConnextAddressToken} from "./connext-address-token";
import {Observable} from "rxjs";

const apiURL = `${contextPath}/api/`;
const connextAddressTokenURL = `${apiURL}connext-address-tokens`;
const dealerConnextAddressTokenURL = `${apiURL}dealer/connext-address-tokens`

@Injectable()
export class ConnextAddressTokensService {
	constructor(private http: HttpClient) {}

	createConnextAddressToken(connextAddressToken: ConnextAddressToken) {
		return this.http.post(`${connextAddressTokenURL}`, connextAddressToken, {responseType: 'text'})
	}

	createConnextAddressTokenForUser(connextAddressToken: ConnextAddressToken, customerGuid: string) {
		return this.http.post(`${dealerConnextAddressTokenURL}/${customerGuid}`, connextAddressToken, {responseType: 'text'})
	}

	getConnextAddressTokens(): Observable<Array<ConnextAddressToken>> {
		return this.http.get<Array<ConnextAddressToken>>(connextAddressTokenURL);
	}

	getConnextAddressTokensForUser(customerGuid: string): Observable<Array<ConnextAddressToken>> {
		return this.http.get<Array<ConnextAddressToken>>(`${dealerConnextAddressTokenURL}/${customerGuid}`);
	}
}
